import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import requestStore from '@/store/requests'

var totp = require('totp-generator')

Vue.use(VueAxios, axios)
Vue.use(Vuex)

axios.defaults.baseURL = 'https://app.meeconn.cz'
axios.defaults.headers.common['X-MC-AT'] = 'f6f8fd66535934d30d31a7ceda75585b71f472e7'
axios.defaults.headers.common['Content-Type'] = 'application/json'

const connectionTypes = ["P","T","V","F"]
const healthStatus = [
      {value: "0", text: 'neuvedeno'},
      {value: "1", text: 'jsem zdravý/á'},
      {value: "2", text: 'cítím se nemocný'},
      {value: "3", text: 'jsem v karanténě'},
      {value: "4", text: 'čekám na testování'},
      {value: "5", text: 'jsem nemocný'}
    ]

const riskLevels = [1,2]

const version = "1.1.0"
const store = new Vuex.Store({
  modules: {
    requests: requestStore
  },
  state: {
    first: false,
    initStatus: false,
//    iid: "VP64BS5FXVYKUZQ4",
//   pid: "BdujGlX-joiCsGQH",
    iid: "",
    pid: "",
    nick: "",
    allowSearchNick: false,
    nicks: {},
    linkNicks: {},
    locationNames: {},
    data: {
      pid: "",
      health: "0",
      zip: '',
      risk: 0,
      network: 0,
/*
      persons: [
        {
          pid: "111",
          type: "P",
          time: "2020-03-17T19:44:29.139Z",
          risk: 12,
          network: 12,
          pstats: {
            p: 10,
            t: 45,
            v: 65
          },
          lstats: {
            p: 3,
            t: 23,
            v: 34
          }
        },
        {
          pid: "222",
          type: "T",
          time: "2020-03-17T19:44:29.139Z",
          risk: 124,
          network: 12,
          pstats: {
            p: 5,
            t: 12,
            v: 3
          },
          lstats: {
            p: 6,
            t: 11,
            v: 21
          }
        }
      ],
*/
      persons: [],
      locations: []
    },
    graphData: null
  },
  getters: {
    isFirst: state => {return state.first},
    sortedPersonConnections: state => {
      /*
      var ordered = []
      Object.keys(state.connections).sort().forEach(function(key) {
        ordered.push(state.connections[key])
      });
      return ordered
      */
      return state.data.persons.sort(function(a, b) {return a.time < b.time})
    },
    sortedLocations: state => {
      return state.data.locations.sort(function(a, b) {return a.time < b.time})
    },
    iid: state => {return state.iid},
    pid: state => {return state.pid},
    nick: state => {return state.nick},
    risk: state => {return state.data.risk},
    health: state => {return state.data.health},
    healthStatus: () => {return healthStatus},
    currentHealthStatus: state => {
      return healthStatus[state.data.health]
    },
    getConnTypeIndex: () => (type) => {
      return connectionTypes.findIndex(t => t === type)
    },
    getRiskColor: state => {
      if (state.data.risk < riskLevels[0]) {
        return 'green'
      } else {
        if (state.data.risk < riskLevels[1]) {
          return 'orange'
        } else {
          return 'red'
        }
      }
    },
    getRiskLevel: state => {
      if (state.data.risk < riskLevels[0]) {
        return "ok"
      } else {
        if (state.data.risk < riskLevels[1]) {
          return "střední"
        } else {
          return "vysoké"
        }
      }
    },
    getRiskLevelNum: state => {
      if (state.data.risk < riskLevels[0]) {
        return 0
      } else {
        if (state.data.risk < riskLevels[1]) {
          return 1
        } else {
          return 2
        }
      }
    },
    getPersonsRisk: state => {
      var res = {ok: 0, med: 0, high: 0}
      state.data.persons.forEach(function (p) {
        if (p.risk < riskLevels[0]) {
          res.ok++
        } else {
          if (p.risk < riskLevels[1]) {
            res.med++
          } else {
            res.high++
          }
        }
      });
      return res
    },
    getOTP: state => {
      return totp(state.iid);
    },
    getLocalData: state => {
      return {
        iid: state.iid,
        pid: state.pid,
        nick: state.nick,
        nicks: state.nicks,
        linkNicks: state.linkNicks,
        loctionNames: state.locationNames
      }
    },
    getVersion: () => {
      return version
    },
    connectionExists: state => pid => {
      var res = false
      for (var i = 0; i < state.data.persons.length; i++) {
        if (state.data.persons[i].pid === pid) {
          res = true
          break
        }
      }
      return res
    },
    getNickOrPid: state => pid => {
      var nick = state.nicks['' + pid]
      if (nick) {
        return nick
      } else {
        return pid
      }
    },
  },
  mutations: {
    first(state, val) {
      state.first = val
    },
    updateIdentity(state, data) {
      state.iid = data.iid
      state.pid = data.pid
      state.data.pid = data.pid
    },
    setIdentity(state, data) {
      state.iid = data.iid
      state.pid = data.pid
      state.data.pid = data.pid
      localStorage.setItem('identity', JSON.stringify(data))
    },
    erase(state) {
      state.iid = null
      state.pid = null
      state.nick = null
      state.nicks = []
      state.linkNicks = []
      localStorage.removeItem('identity')
      localStorage.removeItem('nick')
      localStorage.removeItem('allowSearchNick')
      localStorage.removeItem('nicks')
      localStorage.removeItem('linkNicks')
      localStorage.removeItem('locationNames')
      localStorage.removeItem('placeNames')
      localStorage.removeItem('version')
    },
    addConnection(state, data) {
      state.data.persons.push(data.data)
    },
    updateConnection(state, data) {
      var con = state.data.persons.find(c => c.pid === data.pid)
      con.type = connectionTypes[data.selType]
      state.nicks['' + data.pid] = data.desc
    },
    deleteConnection(state, data) {
      var idx = state.data.persons.findIndex(c => c.pid === data.pid)
      state.data.persons.splice(idx, 1)
    },
    updateNick(state, val) {
      state.nick = val
      localStorage.setItem('nick', val);
    },
    updateAllowSearchNick(state, val) {
      state.allowSearchNick = val
      localStorage.setItem('allowSearchNick', val);
    },
    updateZip(state, val) {
      state.data.zip = val.relocation(' ','')
    },
    updateTribe(state, val) {
      state.data.tribe = val.trim()
    },
    updateHealth(state, val) {
      state.data.health = val
    },
    updateNicks(state, val) {
      state.nicks = val
    },
    updateLinkNicks(state, val) {
      state.linkNicks = val
    },
    addNick(state, data) {
      state.nicks['' + data.pid] = data.nick
      localStorage.setItem('nicks', JSON.stringify(state.nicks));
    },
    setNicks(state, val) {
      state.nicks = val
      localStorage.setItem('nicks', JSON.stringify(state.nicks));
    },
    updateData(state, data) {
      state.data = data
    },
    storeLinkNick(state, data) {
      state.linkNicks['' + data.cor] = data.linkNick
      localStorage.setItem('linkNicks', JSON.stringify(state.linkNicks));
    },
    setLinkNicks(state, val) {
      state.linkNicks = val
      localStorage.setItem('linkNicks', JSON.stringify(state.linkNicks));
    },
    setInitStatus(state, val) {
      state.initStatus = val
    },
    setGraphData(state, val) {
      state.graphData = val
    },
    setVersion(state) {
      state.version = version
      localStorage.setItem('version', version);
    },
    // Locations
    addLocationName(state, data) {
      if (data.name && data.name !== '') {
        state.locationNames['' + data.lid] = data.name
        localStorage.setItem('locationNames', JSON.stringify(state.locationNames));
      } else {
        delete state.locationNames['' + data.lid]
      }
    },
    addLocation(state, data) {
      state.data.locations.push(data)
    },
    setLocationNames(state, val) {
      state.locationNames = val
      localStorage.setItem('locationNames', JSON.stringify(state.locationNames));
    },
    updateLocationNames(state, val) {
      state.locationNames = val
    },
    deleteLocation(state, data) {
      var idx = state.data.locations.findIndex(c => c.lid === data.lid)
      state.data.locations.splice(idx, 1)
      delete state.locationNames['' + data.lid]
      localStorage.setItem('locationNames', JSON.stringify(state.locationNames));
    },
    resetTime(state, pid) {
      state.data.persons.forEach(p => {
        if (p.pid === pid) {
          p.time = new Date()
        }
      });
    },
    resetTimeLocation(state, lid) {
      state.data.locations.forEach(l => {
        if (l.lid === lid) {
          l.time = new Date()
        }
      });
    },
    upgrade11x() {
      /*
      var health = parseInt(state.data.health)
      if (health == 0 || health == 1) {
        state.data.health = 0
      } else {
        if (health == 2 || health == 3) {
          state.data.health = 1
        } else {
          state.data.health = 2
        }
      }
      */
    }
  },
  actions: {
    async init({dispatch, commit}) {
      try {
        var identityData = localStorage.getItem('identity')
        if (identityData) {
          try {
            commit('updateIdentity', JSON.parse(identityData))
          } catch(e) {
            localStorage.removeItem('identity')
          }
        }
        var nick = localStorage.getItem('nick')
        if (nick) {
          commit('updateNick', nick)
        }
        var allowSearchNickData = localStorage.getItem('allowSearchNick')
        if (allowSearchNickData) {
          commit('updateAllowSearchNick', allowSearchNickData)
        } else {
          commit('updateAllowSearchNick', false)
        }
        var nicksData = localStorage.getItem('nicks')
        if (nicksData) {
          try {
            commit('updateNicks', JSON.parse(nicksData))
          } catch(e) {
            localStorage.removeItem('nicks')
          }
        }
        var linkNicksData = localStorage.getItem('linkNicks')
        if (linkNicksData) {
          try {
            commit('updateLinkNicks', JSON.parse(linkNicksData))
          } catch(e) {
            localStorage.removeItem('nicks')
          }
        }
        var locationNamesData = localStorage.getItem('locationNames')
        if (locationNamesData) {
          try {
            commit('updateLocationNames', JSON.parse(locationNamesData))
          } catch(e) {
            localStorage.removeItem('locationNames')
          }
        }
        var loaded = await dispatch('load')

        // check version
        var localVersion = localStorage.getItem('version')
        if (!localVersion && loaded) {
            commit('upgrade11x')
            commit('setVersion')
            commit('setInitStatus', true)
            await dispatch('synchronize')
        } else {
            commit('setVersion')
        }
        commit('setInitStatus', true)
      } catch(err) {
          commit('setInitStatus', false)
          throw err
      }
    },
    async waitOnInit({state}) {
      if (state.initStatus) {
        return true
      } else {
        return this.watch((state) => state.initStatus, () => {
          return true
        })
      }
    },
    async load({ commit, state }) {
      var loaded = false
      if (state.pid) {
        axios.defaults.headers.common['X-MC-PT'] = state.pid
        var otp = totp(state.iid);
        var res
        try {
          res = await axios.get('/api/pl',{headers: {'X-MC-TT': otp}})
        } catch (err) {
          //second try if otp fails
          if (err.response.status === 403 || err.response.status === 401) {
            otp = totp(state.iid);
            res = await axios.get('/api/pl',{headers: {'X-MC-TT': otp}})
          } else {
            throw err
          }
        }
        commit('updateData', res.data)
        loaded = true
      }
      return loaded
    },
    async loadGraph({ commit, state }) {
      if (state.pid) {
        var otp = totp(state.iid);
        var res
        try {
          res = await axios.get('/api/ex',{headers: {'X-MC-TT': otp}})
        } catch (err) {
          //second try if otp fails
          if (err.response.status === 403 || err.response.status === 401) {
            otp = totp(state.iid);
            res = await axios.get('/api/ex',{headers: {'X-MC-TT': otp}})
          } else {
            throw err
          }
        }
        res.data.nodes.forEach(node => {
          node.stateColor = this.colorizeRisk(node.risk)
        });
        commit('setGraphData', res.data)
      }
    },
    async qrpdf({ state }, data) {
      if (state.pid) {
        axios.defaults.headers.common['X-MC-PT'] = state.pid
        var otp = totp(state.iid);
        var res
        try {
          res = await axios.post('/api/qrpdf', data, {headers: {'X-MC-TT': otp}})
        } catch (err) {
          //second try if otp fails
          if (err.response.status === 403 || err.response.status === 401) {
            otp = totp(state.iid);
            res = await axios.post('/api/qrpdf', data, {headers: {'X-MC-TT': otp}})
          } else {
            throw err
          }
        }
        return res
      }
    },
    async generate({ commit }) {
      var res = await axios.get('/api/pid')
      commit('updateIdentity', res.data)
      axios.defaults.headers.common['X-MC-PT'] = res.data.pid
      commit('setIdentity', res.data);
    },
    async restore({ dispatch, commit }, data) {
      axios.defaults.headers.common['X-MC-PT'] = data.pid
      commit('setIdentity', {iid: data.iid, pid: data.pid})
      commit('updateNick', data.nick)
      commit('setNicks', data.nicks)
      commit('setLinkNicks', data.linkNicks)
      commit('setLocationNames', data.locationNames)
      await dispatch('load')
    },
    createConnection({ commit, getters }, data) {
      var exists = getters.connectionExists(data.pid)
      if (exists) {
        return false
      }
      if (data.nick) {
        commit('addNick', {pid: data.pid, nick: data.nick})
      }
      commit('addConnection', {
        data: {
          pid: data.pid,
          type: connectionTypes[data.selType],
          //time: new Date().toLocaleString("en-US", {timeZone: "Europe/Prague"})
          time: new Date(),
          risk: 0,
          network: 0,
          pstats: {p: 0, t: 0, v: 0},
          lstats: {p: 0, t: 0, v: 0},
          flag: 'new',
          cor: data.cor
        },
        nick: data.nick
      })
      return true
    },
    updateConnection({ commit }, data) {
      if (data.desc) {
        commit('addNick', {pid: data.pid, nick: data.desc})
      }
      commit('updateConnection', data)
    },
    deleteConnection({ commit }, data) {
      commit('deleteConnection', data)
    },
    updateNick({commit, dispatch}, val) {
      commit('updateNick', val)
      localStorage.setItem('nick', val);
      dispatch('updateNickOnServer')
    },
    updateAllowSearchNick({commit, dispatch}, val) {
      commit('updateAllowSearchNick', val)
      localStorage.setItem('updateAllowSearchNick', val);
      dispatch('updateNickOnServer')
    },
    updateNickOnServer({dispatch, state}) {
      if (state.allowSearchNick) {
        dispatch('post', {url: '/api/requests/nick', data: {pid: state.pid, nick: state.nick}})
      } else {
        dispatch('post', {url: '/api/requests/nick', data: {pid: state.pid, delete: true}})
      }
    },
    updateZip({commit}, val) {
      commit('updateZip', val)
    },
    async createLocation({commit, state}, val) {
      var res = await axios.get('/api/lid')
      var data = {lid: res.data.lid, time: new Date(), owner: state.data.pid}
      commit('addLocation', data)
      commit('addLocationName', {lid: res.data.lid, name: val.name})
    },
    connectLocation({commit}, data) {
      var val = {lid: data.lid, name: data.name, time: new Date()}
      commit('addLocation', val)
      commit('addLocationName', val)
    },
    connectionExistsAndResetTime({commit, state}, pid) {
      var res = false
      var con = state.data.persons.find(c => c.pid === pid)
      if (con) {
          commit('resetTime', pid)
          res = true
      }
      return res
    },
    locationExistsAndResetTime({commit, state}, lid) {
      var res = false
      var location = state.data.locations.find(l => l.lid === lid)
      if (location) {
          commit('resetTimeLocation', lid)
          res = true
      }
      return res
    },
    async synchronize({ commit, state }) {
      //TODO remove when fixed at server
      var newpid = null
      state.data.persons.forEach(function(person) {
        if (person.flag === "new") {
          newpid = person.pid
        }
      })
      if (state.initStatus) {
        axios.defaults.headers.common['X-MC-PT'] = state.pid
        var otp = totp(state.iid);
        var res
        try {
          res = await axios.post('/api/ps', state.data, {headers: {'X-MC-TT': otp}})
        } catch (err) {
          //second try of otp fails
          if (err.response.status === 403 || err.response.status === 401) {
            otp = totp(state.iid);
            res = await axios.post('/api/ps', state.data, {headers: {'X-MC-TT': otp}})
          } else {
            throw err
          }
        }
        //check cor and linkNicks
        res.data.persons.forEach(function(person) {
          if (person.cor) {
            var linkNick = state.linkNicks['' + person.cor]
            if (linkNick) {
              commit('addNick', {pid: person.pid, nick: linkNick})
            } else {
              if (person.pid != newpid) {
                commit('addNick', {pid: person.pid, nick: person.cor})
              } else {
                person.cor = null
              }
            }
          }
        });
        commit('updateData', res.data)
        //alert(JSON.stringify(res.data))
      } else {
        throw "Bohužel došlo k chybě při inicializaci aplikace"
      }
    },
    async post({ state }, data) {
      if (state.pid) {
        axios.defaults.headers.common['X-MC-PT'] = state.pid
        var otp = totp(state.iid);
        var res
        try {
          res = await axios.post(data.url, data.data, {headers: {'X-MC-TT': otp}})
        } catch (err) {
          //second try if otp fails
          if (err.response.status === 403 || err.response.status === 401) {
            otp = totp(state.iid);
            res = await axios.post(data.url, data.data, {headers: {'X-MC-TT': otp}})
          } else {
            throw err
          }
        }
        return res
      }
    },
    async get({ state }, data) {
      if (state.pid) {
        axios.defaults.headers.common['X-MC-PT'] = state.pid
        var otp = totp(state.iid);
        var res
        try {
          res = await axios.get(data.url, {headers: {'X-MC-TT': otp}})
        } catch (err) {
          //second try if otp fails
          if (err.response.status === 403 || err.response.status === 401) {
            otp = totp(state.iid);
            res = await axios.get(data.url, {headers: {'X-MC-TT': otp}})
          } else {
            throw err
          }
        }
        return res
      }
    }
  }
})

store.colorizeRisk = risk => {
  if (risk < riskLevels[0]) {
    return 'green'
  } else {
    if (risk < riskLevels[1]) {
      return 'orange'
    } else {
      return 'red'
    }
  }
}

export default store
